import { useMemo } from 'react';

import { isDefined, isNotDefined, isNotEmpty, isOfType } from '@hsp/utilities';

import { useSaveStoreSelector } from 'pages/audience/shared/save/hooks/context';
import { IAudience } from 'types/api/audience';

export const useIsExisting = () => {
  const data = useSaveStoreSelector(({ data }) => data);
  const saveAsMaster = useSaveStoreSelector(({ saveAsMaster }) => saveAsMaster);
  const saveAsPreBuilt = useSaveStoreSelector(({ saveAsPreBuilt }) => saveAsPreBuilt);
  const saveTo = useSaveStoreSelector(({ saveTo }) => saveTo);

  return useMemo(() => {
    if (isNotDefined(data) || saveAsMaster || saveAsPreBuilt || saveTo) {
      return false;
    }

    const { id } = data;

    if (isOfType<IAudience>(data, 'category')) {
      return isDefined(id) && isNotEmpty(id);
    }

    const { shopId } = data;

    return isDefined(id) && isNotEmpty(id) && isDefined(shopId) && isNotEmpty(shopId);
  }, [data, saveAsMaster, saveAsPreBuilt, saveTo]);
};
